import { extendTheme } from '@chakra-ui/react';
import '@fontsource-variable/open-sans';

const colors = {
    orange: {
        900: '#521800',
        800: '#7D2700',
        700: '#A83800',
        600: '#CC4A03',
        500: '#e55e14',
        400: '#E9783A',
        300: '#ED925F',
        200: '#F2AB85',
        100: '#F6C5AA',
        50: '#FADFD0',
    },
    blue: {
        900: '#001e62',
        800: '#000573',
        700: '#000D91',
        600: '#0018AA',
        500: '#0026BD',
        400: '#2949C8',
        300: '#526BD2',
        200: '#7A8EDD',
        100: '#A3B1E7',
        50: '#CCD4F2',
    },
};

export const theme = extendTheme({
    fonts: {
        body: `'Open Sans Variable', serif`,
        heading: `'Open Sans Variable', sans-serif`,
    },
    colors: {
        primary: { ...colors.orange },
        secondary: colors.blue['900'],
        tertiary: colors.blue['500'],
        ...colors,
    },
    components: {
        Heading: {
            baseStyle: {
                fontWeight: 800,
            },
        },
        Link: {
            baseStyle: {
                color: 'blue.500',
            },
            variants: {
                primary: {
                    color: 'primary.500',
                },
            },
        },
        FormLabel: {
            baseStyle: {
                fontWeight: 'bold',
            },
        },
        Button: {
            baseStyle: {
                borderRadius: '30px',
            },
        },
        Input: {
            variants: {
                outline: {
                    field: {
                        borderRadius: '30px',
                        _disabled: {
                            bg: 'gray.200',
                            borderColor: 'gray.200',
                            _hover: {
                                borderColor: 'gray.200',
                            },
                        },
                    },
                },
            },
        },
        Checkbox: {
            variants: {
                icon: {
                    container: {
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        gap: 2,
                        justifyContent: 'center',
                    },
                    label: {
                        px: 4,
                        py: 3,
                        m: 0,
                        width: 'full',
                        borderWidth: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        _hover: {
                            bgColor: 'gray.50',
                        },
                        _disabled: {
                            _hover: {
                                bgColor: 'transparent',
                            },
                        },
                    },
                },
            },
        },
        Radio: {
            variants: {
                card: {
                    control: {
                        display: 'none',
                    },
                    container: {
                        borderWidth: '1px',
                        borderRadius: 'full',
                        justifyContent: 'center',
                        px: 4,
                        py: 3,
                        _checked: {
                            borderColor: 'primary.500',
                            bgColor: 'primary.500',
                            color: 'white',
                        },
                        _invalid: {
                            borderColor: 'red.500',
                            boxShadow: '0 0 0 1px var(--chakra-colors-red-500)',
                        },
                    },
                    label: {
                        m: 0,
                    },
                },
            },
        },
    },
});
